<template>
  <q-btn
    flat
    dense
    round
    icon="settings"
    class="settings-button q-ma-sm"
  >
    <q-menu
      anchor="top middle"
      self="bottom left"
      :offset="[0, 10]"
    >
      <q-item style="min-width: 200px;">
        <q-item-section>
          <div class="row justify-between items-center">
            Size
            <q-btn
              v-if="viewOptions.zoom !== 1"
              icon="replay"
              dense
              @click="viewOptions.zoom = 1"
            />
          </div>
          <q-slider
            v-model.number="viewOptions.zoom"
            type="number"
            :min="0.2"
            :max="2"
            :step="0.05"
            label
            debounce="300"
          />
        </q-item-section>
      </q-item>
      <q-separator />
      <q-item
        dense
        clickable
      >
        <q-item-section>
          <q-checkbox
            v-model="viewOptions.hideDistanceShowings"
            label="Auto Zoom To Current Time"
          />
        </q-item-section>
      </q-item>
      <q-item v-if="viewOptions.hideDistanceShowings">
        <q-item-section>
          <div class="row justify-between items-center">
            Zoom Hours
            <q-btn
              v-if="viewOptions.distantShowingThresholdHours !== 3.5"
              icon="replay"
              dense
              @click="viewOptions.distantShowingThresholdHours = 3.5"
            />
          </div>
          <q-slider
            v-model.number="viewOptions.distantShowingThresholdHours"
            type="number"
            :min="0.5"
            :max="5"
            :step="0.25"
            label
            debounce="300"
          />
        </q-item-section>
      </q-item>
      <q-separator />
      <q-item
        dense
        clickable
      >
        <q-item-section>
          <q-checkbox
            v-model="viewOptions.colorByOccupancy"
            label="Color By Occupancy"
          />
        </q-item-section>
      </q-item>
      <q-separator />

      <q-item clickable>
        <q-item-section>Layout</q-item-section>
        <q-item-section side>
          <q-icon name="keyboard_arrow_right" />
        </q-item-section>
        <q-menu
          auto-close
          anchor="top end"
          self="top start"
        >
          <q-list>
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showTimeHeader"
                  label="Show Time Headers"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showTimeSlotHeader"
                  label="Show Time Slot Headers"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showTimes"
                  label="Show Times"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showScreenLabels"
                  label="Show Screen Labels"
                />
              </q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-item>
      <q-separator />
      <q-item clickable>
        <q-item-section>Today</q-item-section>
        <q-item-section side>
          <q-icon name="keyboard_arrow_right" />
        </q-item-section>
        <q-menu
          auto-close
          anchor="top end"
          self="top start"
        >
          <q-list>
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showCurrentTime"
                  label="Show Current Time"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showRelativeTimes"
                  label="Show Relative Times"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showRelativeTimeChips"
                  label="Show Relative Time Chips"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.highlightStartingShowings"
                  label="Highlight Starting Showings"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.highlightCurrentShowings"
                  label="Highlight Current Showings"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.highlightEndingShowings"
                  label="Highlight Ending Showings"
                />
              </q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-item>
      <q-separator />
      <q-item clickable>
        <q-item-section>Details</q-item-section>
        <q-item-section side>
          <q-icon name="keyboard_arrow_right" />
        </q-item-section>
        <q-menu
          auto-close
          anchor="top end"
          self="top start"
        >
          <q-list>
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showTimeChips"
                  label="Show Time Chips"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showRating"
                  label="Show Rating"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showPriceCard"
                  label="Show Price Cards"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showSeatChart"
                  label="Show Seat Chart"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showShowingBadges"
                  label="Show Showing Badges"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showPosters"
                  label="Show Posters"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  v-model="viewOptions.showProgressBar"
                  label="Show Progress Bars"
                />
              </q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-item>
      <q-separator />
      <q-item clickable>
        <q-item-section>Screens</q-item-section>
        <q-item-section side>
          <q-icon name="keyboard_arrow_right" />
        </q-item-section>
        <q-menu
          auto-close
          anchor="top end"
          self="top start"
        >
          <q-list>
            <q-item
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  :model-value="!viewOptions.screenIds"
                  label="All"
                  @update:model-value="toggleAllScreens()"
                />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item
              v-for="screen in screens.data"
              :key="screen.id"
              dense
              clickable
            >
              <q-item-section>
                <q-checkbox
                  :disable="!viewOptions.screenIds"
                  :model-value="!viewOptions.screenIds || $_.includes(viewOptions.screenIds, screen.id)"
                  :label="screen.name"
                  @update:model-value="toggleScreen(screen)"
                />
              </q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-item>
      <q-separator />
      <q-item>
        <q-item-section>
          <div class="row justify-center q-gutter-sm">
            <div class="col-auto">
              <q-btn
                v-close-popup
                :label="saveLabel"
                color="primary"
                size="sm"
                :disable="!isDirty || !canSave"
                @click="$emit('save')"
              />
              <q-tooltip v-if="!canSave">
                Must be in edit mode to save
              </q-tooltip>
            </div>
            <q-btn
              class="col-auto"
              icon="undo"
              size="sm"
              :disable="!isDirty"
              @click="$emit('revert')"
            />
          </div>
        </q-item-section>
      </q-item>
    </q-menu>
  </q-btn>
</template>

<script>
export default {
  name: 'ScheduleMenu',
  props: {
    viewOptions: {
      type: Object,
      required: true
    },
    canSave: {
      type: Boolean,
      required: false,
      default: false
    },
    saveLabel: {
      type: String,
      required: false,
      default: 'Save'
    },
    isDirty: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  configuration: ['screens'],
  emits: ['save', 'revert'],
  methods: {
    toggleAllScreens () {
      if (!this.viewOptions.screenIds) {
        this.viewOptions.screenIds = _.map(this.screens.data, 'id')
      } else {
        this.viewOptions.screenIds = null
      }
    },
    toggleScreen (screen) {
      this.viewOptions.screenIds ||= []
      const index = this.viewOptions.screenIds.indexOf(screen.id)

      if (index > -1) {
        this.viewOptions.screenIds.splice(index, 1)
      } else {
        this.viewOptions.screenIds.push(screen.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .settings-button {
    z-index: 6;
    position: absolute;
    right: 0;
    color: #333;
    opacity: 0.1;
  }
  .settings-button:hover {
    opacity: 1;
  }
</style>
